import React from 'react';
import PropTypes from 'prop-types';
import css from './MultiParameter.APP_TARGET.scss';

const MultiParamenter = ({ keyId, keyName, values }) => (
    <div className={ css.parametersList }>
        <div className={ css.itemParameters }>
            <div className={ css.itemKeyWrapper }>
                <span className={ css.itemName } data-aut-id={ `key_${keyId}` }>{keyName}</span>
            </div>
            <div className={ css.itemValuesWrapper }>
                {values.length === 1 ? (
                    <span
                        className={ css.itemValue }
                        data-aut-id={ `value_${keyId}_0` }
                    >
                        {values[0].formatted_value || values[0].value_name}
                    </span>
                ) : (
                    <ul>
                        {values.map((val, valKey) => (
                            <li
                                key={ `value_${keyId}_${valKey}` }
                                className={ css.itemValue }
                                data-aut-id={ `value_${keyId}_${valKey}` }
                            >
                                {val.formatted_value || val.value_name}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    </div>
);

MultiParamenter.propTypes = {
    keyId: PropTypes.string,
    keyName: PropTypes.string,
    values: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            value_name: PropTypes.string.isRequired,
            formatted_value: PropTypes.string.isRequired
        }).isRequired
    ).isRequired
};

export default MultiParamenter;
